import { hasValue, generateGuid } from "../../../utils/functions.js";

import DateField from "../../common/date-field";

const TIPO_CREDITO = 1;
const TIPO_DEBITO = 2;
// Mesmo limite de LancamentoManual.TamanhoMaximoDescricao no backend
const TAMANHO_MAXIMO_DESCRICAO = 200;
const SITUACAO_VIGENTE = "Vigente";
// ErrorMapping.LANCAMENTO_MANUAL_ADD_NAO_CONFIRMADO no backend
const ERRO_GRAVACAO_NAO_CONFIRMADA = "1332";
// ErrorMapping.LANCAMENTO_MANUAL_POSSIVEL_DUPLICIDADE no backend
const ERRO_POSSIVEL_DUPLICIDADE = "1333";

const filtroVazio = () => ({
  DataInicial: null,
  DataFinal: null,
  IdMerchant: null,
  IdCategoria: null,
  Tipo: null,
  IdUsuario: null,
  Situacao: SITUACAO_VIGENTE
});

const lancamentoVazio = () => ({
  IdCategoria: null,
  Tipo: null,
  Valor: null,
  Descricao: null,
  DataLiberacao: null
});

// O date-field compara datas em UTC: data sem horário (yyyy-MM-dd) evita deslocar o dia
const somenteData = value => (hasValue(value) ? String(value).substring(0, 10) : null);

export default {
  name: "LancamentoManual",
  components: {
    DateField
  },
  data() {
    return {
      pageName: "Lançamentos Manuais",
      tamanhoMaximoDescricao: TAMANHO_MAXIMO_DESCRICAO,
      tipos: [
        { value: TIPO_CREDITO, text: "Crédito" },
        { value: TIPO_DEBITO, text: "Débito" }
      ],
      situacoes: [
        { value: SITUACAO_VIGENTE, text: "Vigentes" },
        { value: "Removido", text: "Removidos da conta corrente" },
        { value: "Todos", text: "Todos" }
      ],
      categorias: [],
      usuarios: [],

      itemList: [],
      loadingList: false,
      countFilter: 0,
      filter: filtroVazio(),
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      lancamentoIncluido: null,

      etapaInclusao: "formulario",
      loadingCalendario: false,
      calendario: {
        Hoje: null,
        DataLiberacaoPadrao: null,
        Feriados: []
      },
      loadingMerchant: false,
      merchantSearch: null,
      merchant: null,
      merchantInvalido: false,
      mensagemMerchant: null,
      novoLancamento: lancamentoVazio(),
      loadingAdd: false,
      // Chave do envio: a mesma enquanto o conteúdo enviado não muda, para o reenvio depois de
      // uma falha sem confirmação não gravar o lançamento duas vezes
      envio: { Chave: null, Conteudo: null },
      // Chave do envio cuja gravação não foi confirmada (falha sem resposta), até confirmar ou provar
      // que não foi gravado
      chaveNaoConfirmada: null,
      // Aviso do backend de lançamento igual feito há pouco: o operador confere ou confirma de novo
      avisoDuplicidade: null
    };
  },

  computed: {
    gravacaoNaoConfirmada() {
      return this.chaveNaoConfirmada != null;
    },
    valorComSinal() {
      const valor = Math.abs(Number(this.novoLancamento.Valor) || 0);
      return this.novoLancamento.Tipo == TIPO_DEBITO ? -valor : valor;
    },
    tipoSelecionado() {
      const tipo = this.tipos.find(t => t.value == this.novoLancamento.Tipo);
      return tipo != null ? tipo.text : "";
    },
    categoriaSelecionada() {
      const categoria = this.categorias.find(c => c.Id == this.novoLancamento.IdCategoria);
      return categoria != null ? categoria.Nome : "";
    },
    feriados() {
      return (this.calendario.Feriados || []).map(somenteData);
    },
    hoje() {
      return somenteData(this.calendario.Hoje);
    }
  },

  watch: {
    "pagination.PageNumber"() {
      this.ListLancamentos();
    },
    "pagination.RowsPerPage"() {
      this.pagination.PageNumber = 1;
      this.ListLancamentos();
    },
    merchantSearch() {
      this.merchant = null;
      this.LimparMerchantInvalido();
    }
  },

  mounted() {
    this.ListLancamentos();
    this.ListarCategorias();
    this.ListarUsuarios();
  },

  methods: {
    hasValue(item) {
      return hasValue(item);
    },

    ObterDescricaoDoTipo(tipo) {
      const tipoEncontrado = this.tipos.find(t => t.value == tipo);
      return tipoEncontrado != null ? tipoEncontrado.text : "";
    },

    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.RecarregarPrimeiraPagina();
    },

    ResetFilter() {
      this.filter = filtroVazio();
      this.RecarregarPrimeiraPagina();
    },

    RecarregarPrimeiraPagina() {
      if (this.pagination.PageNumber == 1) this.ListLancamentos();
      else this.pagination.PageNumber = 1;
    },

    ContarFiltros() {
      return Object.keys(this.filter).filter(chave => {
        // A situação Vigente é o padrão da tela e não conta como filtro aplicado
        const ehFiltroDeSituacao = chave == "Situacao";
        const filtroAplicado = ehFiltroDeSituacao
          ? this.filter.Situacao != SITUACAO_VIGENTE
          : hasValue(this.filter[chave]);
        return filtroAplicado;
      }).length;
    },

    ListLancamentos() {
      this.loadingList = true;
      this.countFilter = this.ContarFiltros();

      const params = {
        PageNumber: this.pagination.PageNumber,
        RowsPerPage: this.pagination.RowsPerPage,
        InitialDate: somenteData(this.filter.DataInicial),
        EndDate: somenteData(this.filter.DataFinal),
        "Object.Merchant.Id": this.filter.IdMerchant,
        "Object.Categoria.Id": this.filter.IdCategoria,
        "Object.Tipo": this.filter.Tipo,
        "Object.Usuario.Id": this.filter.IdUsuario,
        "Object.Situacao": this.filter.Situacao
      };

      this.$store
        .dispatch("ListLancamentoManual", params)
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
          this.ExibirLancamentoIncluido();
        })
        .catch(error => {
          this.lancamentoIncluido = null;
          this.$makeToast("Um erro ocorreu ao listar os lançamentos. Tente novamente.", "danger", "Erro ao listar.", error);
        })
        .finally(() => (this.loadingList = false));
    },

    // A lista é lida da réplica do banco, que pode ainda não ter o lançamento recém-gravado:
    // o lançamento devolvido pela inclusão entra no topo para o operador ver que ele foi feito
    ExibirLancamentoIncluido() {
      const incluido = this.lancamentoIncluido;
      this.lancamentoIncluido = null;

      const semLancamentoIncluido = incluido == null;
      const jaEstaNaLista = !semLancamentoIncluido && this.itemList.some(item => item.Id == incluido.Id);
      if (semLancamentoIncluido || jaEstaNaLista) return;

      this.itemList.unshift(incluido);
      this.pagination.TotalItems++;
      if (this.itemList.length > this.pagination.RowsPerPage) this.itemList.pop();
    },

    ListarCategorias() {
      this.$store
        .dispatch("ListarCategoriasLancamentoManual")
        .then(response => (this.categorias = response))
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao carregar as categorias.", "danger", "Erro ao carregar.", error);
        });
    },

    ListarUsuarios() {
      this.$store
        .dispatch("ListarUsuariosLancamentoManual")
        .then(response => (this.usuarios = response))
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao carregar os usuários.", "danger", "Erro ao carregar.", error);
        });
    },

    OpenModalAdd() {
      this.etapaInclusao = "formulario";
      this.merchantSearch = null;
      this.merchant = null;
      this.LimparMerchantInvalido();
      this.novoLancamento = lancamentoVazio();
      this.avisoDuplicidade = null;
      // A chave do envio e o aviso de gravação não confirmada sobrevivem a fechar a janela: digitar
      // de novo o mesmo lançamento reaproveita a chave e não grava duas vezes
      this.$bvModal.show("mFormLancamento");
      this.CarregarCalendario();
    },

    CarregarCalendario() {
      this.loadingCalendario = true;

      this.$store
        .dispatch("ObterCalendarioLancamentoManual")
        .then(response => {
          this.calendario = response;
          this.novoLancamento.DataLiberacao = somenteData(response.DataLiberacaoPadrao);
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao carregar o calendário.", "danger", "Erro ao carregar.", error);
        })
        .finally(() => (this.loadingCalendario = false));
    },

    // O motivo da recusa fica no próprio campo: merchant inexistente e documento de mais de um
    // merchant pedem ações diferentes do operador
    MarcarMerchantInvalido(mensagem) {
      this.merchantInvalido = true;
      this.mensagemMerchant = mensagem;
    },

    LimparMerchantInvalido() {
      this.merchantInvalido = false;
      this.mensagemMerchant = null;
    },

    BuscarMerchant() {
      if (!hasValue(this.merchantSearch)) {
        const mensagem = "Informe o código ou o documento do merchant.";
        this.MarcarMerchantInvalido(mensagem);
        this.$makeToast(mensagem, "warning", "Busca de merchant");
        return Promise.resolve(null);
      }

      this.loadingMerchant = true;
      this.merchant = null;

      const termo = this.merchantSearch.replace(/\D/g, "");
      const params = termo.length >= 11 ? { documento: termo } : { idMerchant: termo };

      return this.$store
        .dispatch("ObterMerchantLancamentoManual", params)
        .then(response => {
          this.merchant = response;
          this.LimparMerchantInvalido();
          return response;
        })
        .catch(error => {
          // Recusa do backend (merchant inexistente, removido ou documento de mais de um merchant)
          // marca o campo com o motivo; falha de rede não
          const recusadoPeloBackend = error != null && error.HasError === true;
          if (recusadoPeloBackend) this.MarcarMerchantInvalido(error.Error);
          this.$makeToast("Não foi possível buscar o merchant.", "danger", "Busca de merchant", error);
          return null;
        })
        .finally(() => (this.loadingMerchant = false));
    },

    // O tipo (crédito ou débito) define o sinal: o campo valor não aceita sinal
    BloquearSinal(event) {
      if (event.key === "-" || event.key === "+") event.preventDefault();
    },

    ValidarFormulario() {
      const valor = Number(this.novoLancamento.Valor);

      if (!hasValue(this.novoLancamento.IdCategoria)) return "Selecione a categoria.";
      if (!hasValue(this.novoLancamento.Tipo)) return "Selecione se o lançamento é crédito ou débito.";
      if (!(valor > 0)) return "Informe um valor maior que zero.";
      if (!hasValue(this.novoLancamento.Descricao)) return "Informe a descrição.";
      if (!hasValue(this.novoLancamento.DataLiberacao)) return "Informe a data de liberação.";
      return null;
    },

    AvancarParaResumo() {
      // Merchant digitado e não buscado é buscado aqui: inexistente é recusado no próprio campo
      const buscaPendente = this.merchant == null && hasValue(this.merchantSearch);
      const busca = buscaPendente ? this.BuscarMerchant() : Promise.resolve(this.merchant);

      busca.then(() => {
        // Busca feita agora que não trouxe o merchant: o próprio BuscarMerchant já avisou o motivo
        if (buscaPendente && this.merchant == null) return;

        if (this.merchant == null) {
          const mensagem = "Informe um merchant existente pelo código ou documento.";
          this.MarcarMerchantInvalido(mensagem);
          this.$makeToast(mensagem, "warning", "Novo lançamento");
          return;
        }

        const pendencia = this.ValidarFormulario();
        if (pendencia != null) {
          this.$makeToast(pendencia, "warning", "Novo lançamento");
          return;
        }

        this.avisoDuplicidade = null;
        this.etapaInclusao = "resumo";
      });
    },

    VoltarParaFormulario() {
      this.etapaInclusao = "formulario";
      this.avisoDuplicidade = null;
    },

    // Mesma chave enquanto o conteúdo enviado não muda: o backend devolve o lançamento já gravado
    // para uma chave repetida em vez de gravar outro
    ObterChaveDoEnvio(payload) {
      const conteudo = JSON.stringify(payload);
      const conteudoMudou = conteudo != this.envio.Conteudo;
      if (conteudoMudou) this.envio = { Chave: generateGuid(), Conteudo: conteudo };

      return this.envio.Chave;
    },

    // confirmarDuplicidade: o operador viu o aviso de lançamento igual feito há pouco e quer lançar
    ConfirmarLancamento(confirmarDuplicidade = false) {
      this.loadingAdd = true;

      const payload = {
        Merchant: { Id: this.merchant.Id },
        Categoria: { Id: this.novoLancamento.IdCategoria },
        Tipo: this.novoLancamento.Tipo,
        Valor: Math.abs(Number(this.novoLancamento.Valor)),
        Descricao: this.novoLancamento.Descricao.trim(),
        DataLiberacao: this.novoLancamento.DataLiberacao
      };
      // A chave sai só do conteúdo: confirmar o aviso de duplicidade não muda o envio
      const chave = this.ObterChaveDoEnvio(payload);
      payload.ChaveIdempotencia = chave;
      payload.ConfirmarDuplicidade = confirmarDuplicidade === true;

      // Sucesso e falha em ramos separados: um erro ao atualizar a tela depois da gravação não
      // pode ser mostrado como falha do lançamento
      this.$store
        .dispatch("AddLancamentoManual", payload)
        .then(
          response => this.ConcluirLancamento(response),
          error => this.TratarFalhaDoLancamento(error, chave)
        )
        .finally(() => (this.loadingAdd = false));
    },

    ConcluirLancamento(response) {
      // Os filtros são limpos para o lançamento novo aparecer no topo da lista
      const tinhaFiltro = this.countFilter > 0;
      this.filter = filtroVazio();
      this.lancamentoIncluido = response;
      // Gravação confirmada: o próximo lançamento, mesmo com os mesmos dados, é outro envio
      this.chaveNaoConfirmada = null;
      this.envio = { Chave: null, Conteudo: null };
      this.avisoDuplicidade = null;

      this.$makeToast(
        "Lançamento incluído com sucesso." + (tinhaFiltro ? " Os filtros foram limpos para exibi-lo na lista." : ""),
        "success",
        "Novo lançamento"
      );
      this.$bvModal.hide("mFormLancamento");
      this.ListarUsuarios();
      this.RecarregarPrimeiraPagina();
    },

    // Em qualquer falha a janela continua aberta com o que foi digitado. Sem confirmação da gravação
    // (falha do banco depois do envio, sem resposta do servidor ou erro 5xx no caminho) o operador
    // fica no resumo e pode confirmar de novo: a chave do envio impede o lançamento em dobro, mesmo
    // que ele feche a janela e digite o mesmo lançamento. Os demais erros (recusa do backend, 400,
    // 401/403 do controle de acesso) voltam ao formulário, porque nada foi gravado
    TratarFalhaDoLancamento(error, chave) {
      const statusHttp = error != null && error.response != null ? error.response.status : null;
      const respostaDoBackend = error != null && error.HasError === true;
      const naoConfirmadoPeloBackend = respostaDoBackend && error.ErrorCode == ERRO_GRAVACAO_NAO_CONFIRMADA;
      const semRespostaDoServidor = !respostaDoBackend && statusHttp == null;
      const falhaNoServidor = statusHttp != null && statusHttp >= 500;
      const gravacaoSemConfirmacao = naoConfirmadoPeloBackend || semRespostaDoServidor || falhaNoServidor;
      const lancamentoIgualRecente = respostaDoBackend && error.ErrorCode == ERRO_POSSIVEL_DUPLICIDADE;

      // Lançamento igual feito há pouco: nada foi gravado; o operador fica no resumo com o aviso e
      // decide entre conferir a lista e lançar mesmo assim
      if (lancamentoIgualRecente) {
        if (chave == this.chaveNaoConfirmada) this.chaveNaoConfirmada = null;
        this.avisoDuplicidade = error.Error;
        return;
      }

      if (!gravacaoSemConfirmacao) {
        // O backend procura a chave antes de validar: recusa do envio pendente prova que ele não foi
        // gravado. Recusa de outro envio não diz nada sobre o pendente, que continua avisado.
        if (respostaDoBackend && chave == this.chaveNaoConfirmada) this.chaveNaoConfirmada = null;
        this.etapaInclusao = "formulario";
        // Com o erro do axios, o $makeToast já não mostra 401/403 (a navegação do interceptor trata)
        this.$makeToast("Um erro ocorreu ao incluir o lançamento.", "danger", "Erro ao incluir.", error);
        return;
      }

      this.chaveNaoConfirmada = chave;
      this.RecarregarPrimeiraPagina();
      this.$makeToast(
        "Não foi possível confirmar se o lançamento foi gravado. Pode confirmar de novo: o mesmo lançamento não é gravado duas vezes.",
        "warning",
        "Lançamento não confirmado"
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/LancamentoManual/LancamentoManual.js